// src/components/charts/GrainCharts.js — SAME FONT WEIGHT
import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";
import { formatDateBS } from "../../utils/dateUtils";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";
import "./ChartContainer.css";

export default function GrainCharts() {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        const fetchChartData = async () => {
            try {
                const data = await client.fetch(`
          *[_type == "grainTransaction"]{
            buyOrSell,
            quantity,
            time
          }
        `);

                const grouped = {};
                data.forEach((t) => {
                    const dateObj = new Date(t.time);
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    const d = `${year}-${month}-${day}`;
                    if (!grouped[d]) grouped[d] = { date: d, Buy: 0, Sell: 0 };
                    if (t.buyOrSell === "Buy") grouped[d].Buy += parseFloat(t.quantity) || 0;
                    else if (t.buyOrSell === "Sell") grouped[d].Sell += parseFloat(t.quantity) || 0;
                });

                const formatted = Object.values(grouped).sort(
                    (a, b) => new Date(a.date) - new Date(b.date)
                );
                setChartData(formatted);
            } catch (err) {
                console.error("Error fetching grain chart data:", err);
            }
        };

        fetchChartData();
    }, []);

    return (
        <div className="chart-container">
            <h6 className="chart-title-center">Grain Volume Over Time</h6>
            <div style={{ width: "100%", height: 260 }}>
                <ResponsiveContainer>
                    <BarChart
                        data={chartData}
                        margin={{ top: 5, right: 20, left: 20, bottom: 40 }}
                    >
                        <CartesianGrid strokeDasharray="5 5" stroke="#e0e0e0" />
                        <XAxis
                            dataKey="date"
                            tick={{ fontSize: 12, fill: "#065f46", fontWeight: 600 }}
                            angle={-45}
                            textAnchor="end"
                            height={70}
                            tickFormatter={(value) => formatDateBS(value)}
                        />
                        <YAxis
                            tick={{ fontSize: 12, fill: "#065f46", fontWeight: 600 }}
                            tickFormatter={(value) => `${value} kg`}
                            width={70}
                        />
                        <Tooltip
                            contentStyle={{
                                background: "#fff",
                                border: "2px solid #34d399",
                                borderRadius: "12px",
                                padding: "10px",
                                fontSize: "13px"
                            }}
                            labelStyle={{ color: "#065f46", fontWeight: 800 }}
                            itemStyle={{ fontWeight: 600 }}
                            labelFormatter={(value) => formatDateBS(value)}
                        />
                        <Legend
                            verticalAlign="top"
                            height={32}
                            wrapperStyle={{ top: 0, fontWeight: 700 }}
                        />
                        <Bar
                            dataKey="Buy"
                            fill="#dc2626"
                            radius={[8, 8, 0, 0]}
                            name="Bought"
                            barSize={30}
                        />
                        <Bar
                            dataKey="Sell"
                            fill="#059669"
                            radius={[8, 8, 0, 0]}
                            name="Sold"
                            barSize={30}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}